<script lang="ts">
  import { onMount } from "svelte";
  import Tab from "../../components/Tab/Tab.svelte";
  import Tabs from "../../components/Tab/Tabs.svelte";
  import { navigate } from "../../app.logic";
  import { ChallengePage } from "./challenge-tab";

  // statement, attachments, stats, submissions

  export let sectionId: number;
  export let challengeId: number;
  export let tab: ChallengePage;

  let currentTab: ChallengePage = ChallengePage.General;

  onMount(() => {
    //currentTab = submissions ? ChallengePage.Submissions : ChallengePage.General;
    currentTab = tab;
  });
</script>

<Tabs>
  <Tab
    label="General"
    active={currentTab == ChallengePage.General}
    on:click={(_) => {
      navigate(`/task/${sectionId}/${challengeId}/general`);
    }}
  />
  <Tab
    label="Files"
    active={currentTab == ChallengePage.Files}
    on:click={(_) => {
      navigate(`/task/${sectionId}/${challengeId}/files`);
    }}
  />
  <Tab
    label="Submissions"
    active={currentTab == ChallengePage.Submissions}
    on:click={(_) => {
      navigate(`/task/${sectionId}/${challengeId}/submission`);
    }}
  />
</Tabs>
